<template>
  <div class="flex flex_between">
    <md-field :class="{ 'select-error': isError }">
      <label>{{ $t('common.year') }}</label>
      <TbSelect v-model="moduleValue"
				@md-selected="onSelect"
				:search-allow="true"
				:options="options"
				:required="required"
      />
    </md-field>
  </div>
</template>
<script>
import {dashboardInspectionApi} from "@/common/api/dashboardInspectionApi";
import {mapGetters} from "vuex";

export default {
  props: {
    labelText: {
      type: String,
      default: "value"
    },
    isError: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      moduleValue: "",
      options: []
    };
  },
  mounted() {
    this.options=[moment().format("YYYY")]
    this.getList();
  },
  methods: {
    onSelect() {
      this.$store.dispatch("setActionDashboardFilter", { years: this.moduleValue });
      this.$emit("onSelect", this.moduleValue);
    },
    getList() {
      let { type } = this.dashboardFilter;
      
      dashboardInspectionApi[type]
        .years()
        .then(res => {
            this.options = res;
            this.moduleValue=this.options[0]
            this.onSelect()
        })
        .catch(err => {
          console.log("err", err);
           this.moduleValue=this.options[0]
            this.onSelect()
        });
    }
  },
  computed: {
    ...mapGetters({ dashboardFilter: "dashboardFilter" }),
  },
  watch: {
    "dashboardFilter.type"() {
      this.getList();
    }
  }
};
</script>
